// extracted by mini-css-extract-plugin
export default {"tabs__titles":"Tabs_tabs__titles__6fym6","tabs":"Tabs_tabs__mElEu"};